var map = {
	"./0.png": 6440,
	"./1.png": 9153,
	"./10.png": 6229,
	"./11.png": 3340,
	"./12.png": 8167,
	"./13.png": 478,
	"./14.png": 6593,
	"./15.png": 6648,
	"./16.png": 3507,
	"./17.png": 8282,
	"./18.png": 5789,
	"./19.png": 9636,
	"./2.png": 170,
	"./20.png": 2320,
	"./2R.png": 2610,
	"./3.png": 931,
	"./4.png": 7324,
	"./5.png": 4837,
	"./6.png": 6062,
	"./7.png": 6055,
	"./8.png": 2224,
	"./9.png": 7977,
	"./B.png": 3626,
	"./BP.png": 880,
	"./G.png": 4135,
	"./GP.png": 791,
	"./INF.png": 61,
	"./P.png": 3192,
	"./R.png": 6890,
	"./RP.png": 9104,
	"./T.png": 1404,
	"./Tv2.png": 5760,
	"./Tv3.png": 585,
	"./U.png": 7317,
	"./UP.png": 6161,
	"./UT.png": 5493,
	"./W.png": 8983,
	"./WP.png": 823,
	"./X.png": 2624,
	"./Y.png": 8873,
	"./Z.png": 2290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3561;